export const API_URL =
  process.env.REACT_APP_API_URL || "https://germany-ranking.herokuapp.com";

export enum Country {
    Germany = 'germany',
    Austria = 'austria',
}